(function () {
    'use strict';
    angular.module('emarket.store.search', [ 'ui.router' ]).config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('store.search', {
            url: '/buscar?q?category?province?usuario',
            views: {
                store: {
                    templateUrl: 'store/search/store-search.tpl.html',
                    controller: 'StoreSearchController as model'
                }
            },
            reloadOnSearch : false
        }).state('store.search-bar', {
            url: '/iniciar-busqueda',
            views: {
                store: {
                    templateUrl: 'store/search/store-search.tpl.html'
                }
            }
        });
    }]);
}());

(function () {
    'use strict';
    angular.module('emarket.store.search', [ 'ui.router' ]).config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('store.search', {
            url: '/buscar?q?category?province?usuario',
            views: {
                store: {
                    templateUrl: 'store/search/store-search.tpl.html',
                    controller: 'StoreSearchController as model'
                }
            },
            reloadOnSearch : false
        }).state('store.search-bar', {
            url: '/iniciar-busqueda',
            views: {
                store: {
                    templateUrl: 'store/search/store-search.tpl.html'
                }
            }
        });
    }]);
}());
